import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/register.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/tabbar/home.vue'),
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/tabbar/mine.vue'),
  },
  {
    path: '/lottery',
    name: 'lottery',
    component: () => import('../views/lottery/index.vue'),
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('../views/lottery/record.vue'),
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('../views/setting/index.vue'),
  },
  {
    path: '/user_info',
    name: 'user_info',
    component: () => import('../views/setting/user_info.vue'),
  },
  {
    path: '/bank_card_info',
    name: 'bank_card_info',
    component: () => import('../views/setting/bank_card_info.vue'),
  },
  {
    path: '/bind_bank_card',
    name: 'bind_bank_card',
    component: () => import('../views/setting/bind_bank_card.vue'),
  },
  {
    path: '/set_psd',
    name: 'set_psd',
    component: () => import('../views/setting/set_psd.vue'),
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/wallet/report.vue'),
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import('../views/wallet/recharge.vue'),
  },
  {
    path: '/recharge_record',
    name: 'recharge_record',
    component: () => import('../views/wallet/recharge_record.vue'),
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: () => import('../views/wallet/withdrawal.vue'),
  },
  {
    path: '/withdrawal_record',
    name: 'withdrawal_record',
    component: () => import('../views/wallet/withdrawal_record.vue'),
  },
]

const router = new VueRouter({
  routes
})

export default router
